import { apiClient } from '../services/apiClient';
import type { LicenseDto } from './libraryApi';

/** The collected free-text vocabularies the Dictionary Manager can edit (006 FR-079..FR-086). */
export type VocabularyKind = 'genre' | 'mood' | 'tempo' | 'tag';

export interface VocabularyValueDto {
  value: string;
  trackCount: number;
}

export interface VocabularyUsageDto {
  genres: VocabularyValueDto[];
  moods: VocabularyValueDto[];
  tempos: VocabularyValueDto[];
  tags: VocabularyValueDto[];
}

/** The number of tracks a rename/merge/delete actually changed. */
export interface AffectedCountResponse {
  affected: number;
}

export function fetchVocabulary(): Promise<VocabularyUsageDto> {
  return apiClient.get<VocabularyUsageDto>('/admin/vocabulary');
}

export function renameVocabulary(
  kind: VocabularyKind, oldValue: string, newValue: string,
): Promise<AffectedCountResponse> {
  return apiClient.post<AffectedCountResponse>('/admin/vocabulary/rename', { kind, oldValue, newValue });
}

export function mergeVocabulary(
  kind: VocabularyKind, sources: string[], target: string,
): Promise<AffectedCountResponse> {
  return apiClient.post<AffectedCountResponse>('/admin/vocabulary/merge', { kind, sources, target });
}

export function deleteVocabularyValue(
  kind: VocabularyKind, value: string,
): Promise<AffectedCountResponse> {
  return apiClient.post<AffectedCountResponse>('/admin/vocabulary/delete', { kind, value });
}

// ─── Licenses: rename + merge (the managed-vocabulary half of the Dictionary Manager) ───

export function renameLicense(licenseId: string, name: string): Promise<LicenseDto> {
  return apiClient.post<LicenseDto>(`/admin/licenses/${licenseId}/rename`, { name });
}

export function mergeLicenses(sourceId: string, targetId: string): Promise<AffectedCountResponse> {
  return apiClient.post<AffectedCountResponse>('/admin/licenses/merge', { sourceId, targetId });
}
